export default "__VITE_ASSET__CJbEnsw3__"